/*
入口JS
 */
import React from 'react';
import ReactDOM from 'react-dom';
import 'element-theme-default';
import { BrowserRouter, HashRouter, Switch, Route, Link } from 'react-router-dom'
import NavMenu from './components/navMenu/navMenu';
import Index from './pages/index/index';
import ShopProduct from './pages/shopProduct/shopProduct';
import DistributionLog from './pages/distributionLog/distributionLog';
import MyAuth from './pages/myAuth/myAuth';
import DistributionSet from './pages/distributionSet/distributionSet';
import AutoAfterSaleLog from './pages/autoAfterSaleLog/autoAfterSaleLog';
import AutoAfterSaleSet from './pages/autoAfterSaleSet/autoAfterSaleSet';
import OrderBackflowLog from './pages/orderBackflowLog/orderBackflowLog';
import OrderBackflowSet from './pages/orderBackflowSet/orderBackflowSet';
import ProxyProduct from './pages/proxyProduct/proxyProduct';
import ProcurementOrder from './pages/procurementOrder/procurementOrder';
import OrderList from './pages/orderList/orderList';
import BatchUpdatePrice from './pages/batchUpdatePrice/batchUpdatePrice';
import OfferSearch from './pages/offerSearch/offerSearch';
import ImageSearchProduct from './pages/ImageSearchProduct/ImageSearchProduct';
import AlibabaSearchProduct from './pages/alibabaSearchProduct/alibabaSearchProduct';
import AlibabaRecommendProduct from './pages/alibabaRecommendProduct/alibabaRecommendProduct';
import SupplierMarke from './pages/supplierMarke/supplierMarke';
import ProductImageText from './pages/productImageText/productImageText';
import OfficialWarehouseAfterSalesOrder from './pages/officialWarehouseAfterSalesOrder';
import OfficialReturnWarehouse from './pages/officialReturnWarehouse';
import { requests,loadZhuKeToken,systemConfig } from './utils/http';
import { LoadContactWayRequest } from './utils/api';
import { createBrowserHistory } from 'history'
import axios from 'axios';
import { MessageBox } from 'element-react';



var tokenUrl = "";
var url = window.parent.location.href;
var arrObj = url.split("?");
if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");
        if (arr != null && arr[0] == "token") {
          tokenUrl= arr[1];
        }
    }
}

localStorage.removeItem('components_navMenu_quickGuideData')
//初始化token
if(tokenUrl !=""){
  loadZhuKeToken(tokenUrl);//链接有带Token过来的
  //跳转过来的token，缓存起来
  localStorage.setItem("hasZhukeLoginShopTokens", tokenUrl);
}else{
  var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
  if(hasZhukeLoginShopTokens !=null && hasZhukeLoginShopTokens !="" && hasZhukeLoginShopTokens !=undefined){
    loadZhuKeToken(hasZhukeLoginShopTokens);
  }
}



LoadContactWayRequest().then(res =>{
  if(res.Data && res.Data.ContactWayList)
  {
    try{
      systemConfig.ContactWayList = JSON.parse(res.Data.ContactWayList)
      systemConfig.QQContactWay = systemConfig.ContactWayList.find(s => s.QQ)
    }catch(e){ }
  }
})

ReactDOM.render((
  <HashRouter>
    <Switch>
      <Route path="/index" component={Index} />
      <Route path="/DistributionLog" component={DistributionLog} />
      <Route path="/MyAuth" component={MyAuth} />
      <Route path="/ShopProduct" component={ShopProduct} />
      <Route path="/DistributionSet" component={DistributionSet} />
      <Route path="/AutoAfterSaleLog" component={AutoAfterSaleLog} />
      <Route path="/AutoAfterSaleSet" component={AutoAfterSaleSet} />
      <Route path="/OrderBackflowLog" component={OrderBackflowLog} />
      <Route path="/OrderBackflowSet" component={OrderBackflowSet} />
      <Route path="/ProxyProduct" component={ProxyProduct} />
      <Route path="/ProcurementOrder" component={ProcurementOrder} />
      <Route path="/OrderList" component={OrderList} />
      <Route path="/BatchUpdatePrice" component={BatchUpdatePrice} />
      <Route path="/OfferSearch" component={OfferSearch} />
      <Route path="/ImageSearchProduct" component={ImageSearchProduct} />
      <Route path="/AlibabaSearchProduct" component={AlibabaSearchProduct} />
      <Route path="/AlibabaRecommendProduct" component={AlibabaRecommendProduct} />
      <Route path="/SupplierMarke" component={SupplierMarke} />
      <Route path="/ProductImageText" component={ProductImageText} /> 
      <Route path="/OfficialWarehouseAfterSalesOrder" component={OfficialWarehouseAfterSalesOrder} />
      <Route path="/OfficialReturnWarehouse" component={OfficialReturnWarehouse} />
      <Route component={MyAuth}></Route> 默认路由
    </Switch>
  </HashRouter>


), document.getElementById('root'))


/**
 * 增加版本号
 * （全局版本请求拦截器,有其他业务需求另外用use写一个方法,use采用责任链模式）
 */
axios.interceptors.request.use(req =>{
  req.headers['ClientType'] = 'SELF_VERSION'
  return req;
})



// WEBPACK FOOTER //
// ./src/index.js